// extracted by mini-css-extract-plugin
export default {"desktop-navigation":"desktop-navigation--Tfk5R"};